import {Prop, Vue} from "vue-property-decorator";
import {CustomFormFieldCreateOrUpdateDto, SelectListItem} from "@/api/appService";
import {resolveSelectOptions} from "@/components/CustomForm/common";


export abstract class AbstractDataSourceView extends Vue {


  @Prop({required: true})
  formControl!: CustomFormFieldCreateOrUpdateDto;

  @Prop({required: false, default: ''})
  value!: string;

  private _loading = true;

  dataSource: SelectListItem[] = []



  protected initDataSource(){
    if (!this._loading) {
      resolveSelectOptions(this.formControl).then(res => {
        this.dataSource = res??[];
        this._loading = false;
        console.log(this.dataSource)
      })
    }
  }


}
